import { inject, observer } from 'src/core/store'
import React from 'react'
import menu from 'src/core/menu'
import { Layout, Menu, Icon } from 'antd'
import { Link } from 'src/core/router'
const { Sider } = Layout
const { SubMenu } = Menu
import localstorage from 'src/helper/localstorage'

@inject('store')
@observer
export default class extends React.Component {
  state = {
    collapsed: false
  }
  onCollapse = (collapsed) => {
    this.setState({ collapsed })
  }

  getMenu() {
    const userInfo = localstorage.get('userToken') || ''

    return menu.data.map((v, k) => {
      if ((userInfo.power & v.power) == v.power) {
        if (!v.sub || v.sub.length === 0) { //权限判断
          return (
            <Menu.Item key={v.key}>
              <Link to={v.key}>
                <Icon type={v.icon} /><span>{v.name}</span>
              </Link>
            </Menu.Item>
          )
        } else {
          return (
            <SubMenu
              key={v.key}
              title={<span><Icon type={v.icon} /><span>{v.name}</span></span>}
            >
              {(v.sub.map((vo, ko) => {
                // console.log(vo.uids && vo.uids.indexOf(userInfo.uid), vo.uids, userInfo.uid, vo.name)
                if ((userInfo.power & vo.power) == vo.power ||  vo.uids && vo.uids.indexOf(userInfo.uid) > -1) {
                  return (
                    <Menu.Item key={vo.key}>
                      <Link to={vo.key}>
                        {vo.name}
                      </Link>
                    </Menu.Item>
                  )
                }
              }))}
            </SubMenu>
          )
        }
      }
    })
  }
  render() {
    const { module, controller, action } = this.props.params
    return (
      <Sider
        className='slide'
        collapsible
        collapsed={this.state.collapsed}
        onCollapse={this.onCollapse}
      >
        <div className="logo" />
        <Menu theme="dark" defaultOpenKeys={[`/${module}/${controller}`]} selectedKeys={[`/${module}/${controller}/${action}`]} mode="inline">
          {(this.getMenu())}
        </Menu>
      </Sider>
    )
  }
}



// WEBPACK FOOTER //
// ./layout/Sider.js